<h1>Admin Dashboard</h1>

<div style="display: flex; flex-direction: column; gap: 8px;">
    <mat-card routerLink="/admin/users">
        <mat-card-header>   
            <mat-card-title>
                <span>Users</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            {{ adminService.totalUserCount }} users &middot; {{ adminService.totalPatreonCount }} patrons
        </mat-card-content>
    </mat-card>
    
    <mat-card routerLink="/admin/scripts">
        <mat-card-header>
            <mat-card-title>
                <span>Scripts</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            1234 submitted &middot; 1234 approved
        </mat-card-content>
    </mat-card>
    
    <mat-card routerLink="/admin/gamenight">
        <mat-card-header>
            <mat-card-title>
                <span>Gamenight</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Manage voting options &middot; View vote results
        </mat-card-content>
    </mat-card>
    
    <mat-card routerLink="/admin/stats">
        <mat-card-header>
            <mat-card-title>
                <span>Stats</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Manage stat definitions &middot; View tracking data
        </mat-card-content>
    </mat-card>
    
    <mat-card routerLink="/admin/knowledge_base">
        <mat-card-header>
            <mat-card-title>
                <span>Cult Bot Knowledge</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Manage Discord bot knowledge base &middot; Add, edit, and publish reference pages
        </mat-card-content>
    </mat-card>

    <mat-card routerLink="/admin/performance">
        <mat-card-header>
            <mat-card-title>
                <span>Performance</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            View performance tracking distributions
        </mat-card-content>
    </mat-card>

    <mat-card routerLink="/admin/errors">
        <mat-card-header>
            <mat-card-title>
                <span>Errors</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            View error reports
        </mat-card-content>
    </mat-card>
</div>